export default {
      id: "color_ancestry-usage",
      viewBox: "0 0 45 64",
      url: __webpack_public_path__ + "sprite.svg#color_ancestry",
      toString: function () {
        return this.url;
      }
    }